import { StoreOfferProduct } from '@common'
import { useTranslations } from 'next-intl'

import { useIsLoggedIn } from '../../common/useIsLoggedIn'
import { Bundles } from '../_storeBase/bundles/Bundles'
import { STORE_BG } from '../_storeBase/constants'
import { Offers } from '../_storeBase/offers/Offers'
import Passes from '../_storeBase/passes/Passes'
import { ProductCategory } from '../_storeBase/productCategory/ProductCategory'
import { BonusContainer as BonusContainerV2 } from '../_storeBase/storeBonusV2'
import { LogInBonusFooter } from '../_storeBase/storeBonusV2/bonusFooter/LogInBonusFooter'
import { GameContainer } from '../_storeBase/structure/GameContainer'
import { StoreContent } from '../_storeBase/structure/StoreContent'
import { isStoreSpecial, isNormalOffer, isSeasonPass, sortByPriority } from '../productFilters'
import { StoreFrontProps } from '../types'

import styles from './brawlstars.module.scss'

const BrawlStarsStoreFront = ({ products, bonusStatus, enableNewVisuals }: StoreFrontProps) => {
  const gameId = 'brawlstars'
  const loggedIn = useIsLoggedIn()
  const t = useTranslations()

  const specials = products.filter(isStoreSpecial).sort(sortByPriority) as StoreOfferProduct[]
  const normalOffers = products.filter(isNormalOffer).sort(sortByPriority) as StoreOfferProduct[]
  const passes = products
    .filter(isSeasonPass)
    .filter((product) => !product.id.includes('seasonpass.basic')) as StoreOfferProduct[]
  const otherProducts = products
    .filter((product) => !isStoreSpecial(product) && !isNormalOffer(product) && !isSeasonPass(product))
    .sort(sortByPriority)

  return (
    <GameContainer>
      <StoreContent>
        <Bundles bundles={specials} enableNewVisuals={enableNewVisuals} />
        <Passes products={passes} enableNewVisuals={enableNewVisuals} />
        <div className={styles.productsSection}>
          <div className={styles.rotatedBg} style={{ backgroundImage: STORE_BG(gameId) }} />
          <Offers products={normalOffers} gameId={gameId} enableNewVisuals={enableNewVisuals} />
          <ProductCategory
            title={t('game_cat_gems')}
            displayTitle={false}
            products={otherProducts}
            productType="GEM"
            enableNewVisuals={enableNewVisuals}
          />
        </div>
      </StoreContent>
      {loggedIn && bonusStatus ? <BonusContainerV2 bonusStatus={bonusStatus} /> : <LogInBonusFooter />}
    </GameContainer>
  )
}

export default BrawlStarsStoreFront
